import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { EI_WIDGET_TYPES, EI_WIDGET_LIST, eiDefaultWidgets, EI_WIDGET_TYPE_MAP } from './ei';
import {
  ECO_WIDGET_TYPES,
  ECO_WIDGET_LIST,
  getEcoDefaultWidgets,
  ECO_WIDGET_TYPE_MAP,
} from './eco';

export const WIDGET_TYPES =
  {
    EI: EI_WIDGET_TYPES,
    APP: ECO_WIDGET_TYPES,
  }[CURRENT_PRODUCT_MODE] || {};

// widget list contains list of supported widgets and default state
// persisted state will only contain essential keys, rest of it(meta) is appended from widget type map
// TODO: build a widget type map for lookups
export const WIDGET_LIST =
  {
    EI: EI_WIDGET_LIST,
    APP: ECO_WIDGET_LIST,
  }[CURRENT_PRODUCT_MODE] || [];

// default widgets
export const getDefaultWidgets = () => {
  return (
    {
      EI: eiDefaultWidgets,
      APP: getEcoDefaultWidgets(),
    }[CURRENT_PRODUCT_MODE] || {}
  );
};

export const WIDGET_TYPE_MAP =
  {
    EI: EI_WIDGET_TYPE_MAP,
    APP: ECO_WIDGET_TYPE_MAP,
  }[CURRENT_PRODUCT_MODE] || [];

export const widgetTypeKeys = {};
Object.keys(WIDGET_TYPES).forEach((k) => {
  widgetTypeKeys[k] = k;
});
